import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../styles/max-container-width/max-container-width.style';
import { mediaQueryValues } from '../../media-query';
import {
  centeredBox,
  extraSmallMarginBottomBox,
  extraSmallPaddingVerticalBox,
  extraSmallPaddingHorizontalOptionButton,
  mediumPaddingHorizontalBox,
  smallPaddingBox,
  smallPaddingVerticalBox,
} from '../../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
  },
  section: {
    flex: 1,
    ...maxContainerWidthStyle,
  },
  image: {
    height: mediaQuery.smallImage,
  },
  view: {
    display: 'flex',
    ...centeredBox,
    ...mediumPaddingHorizontalBox,
    ...smallPaddingVerticalBox,
  },
  text: {
    ...extraSmallMarginBottomBox,
  },
  hint: {
    ...centeredBox,
    flexDirection: 'row',
  },
  answer: {
    ...centeredBox,
    ...extraSmallPaddingVerticalBox,
    flexDirection: 'row',
  },
  hintText: {
    ...extraSmallPaddingHorizontalOptionButton,
  },
  optionsContainer: {
    ...smallPaddingBox,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginHorizontal: -3,
  },
  answerContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    marginHorizontal: -6,
    flexGrow: 0,
    flexShrink: 1,
  },
  optionBubbleContainer: {
    marginHorizontal: 1,
  },
  optionBubble: {
    paddingHorizontal: 10,
    paddingVertical: 2,
  },
  largeOptionBubble: {
    marginHorizontal: 2,
    paddingHorizontal: 14,
    paddingVertical: 4,
  },
  // eslint-disable-next-line react-native/no-color-literals
  emptyFragment: {
    marginBottom: 1,
    borderBottomWidth: 2,
    borderStyle: 'dashed',
    borderColor: 'rgba(255,255,255,0.8)',
    backgroundColor: 'rgba(255,255,255,0.2)',
    opacity: 1,
    paddingHorizontal: 12,
  },
  word: {
    flexDirection: 'row',
    marginVertical: 6,
    marginHorizontal: 6,
  },
});
